import React from 'react';
import { AutoComplete } from "primereact/autocomplete";
import ContactInfo from './ContactInfo';
import styles from '../App.module.less';

const CMESearchForm = ({
  autocompleteValue,
  setAutocompleteValue,
  filteredCounties,
  onAutocompleteSearch,
  showZipcodeInput,
  autocompleteZipcodeValue,
  setAutocompleteZipcodeValue,
  filteredZipcodes,
  onAutocompleteZipcodeSearch,
  onSubmit
}) => {
  return (
    <>
      <div className={`${styles.header} ${styles.cmeF35}`}>
        Search for Your Care Management Entity
      </div>

      <div className={styles.inputs}>
        <label className={styles.cmeF26}>
          Select County
          <AutoComplete
            appendTo="self"
            dropdown={true}
            inputClassName={styles.cmeF26}
            delay={0}
            value={autocompleteValue}
            suggestions={filteredCounties}
            completeMethod={onAutocompleteSearch}
            onChange={(e) => setAutocompleteValue(e.value)}
          />
        </label>

        {showZipcodeInput && (
          <label className={`${styles.zipcodes} ${styles.cmeF26}`}>
            Zip Code
            <AutoComplete
              forceSelection={true}
              appendTo="self"
              dropdown={true}
              inputClassName={styles.cmeF26}
              delay={0}
              value={autocompleteZipcodeValue}
              suggestions={filteredZipcodes}
              completeMethod={onAutocompleteZipcodeSearch}
              onChange={(e) => setAutocompleteZipcodeValue(e.value)}
              keyfilter="int"
            />
          </label>
        )}

        <button className={`${styles.submitButton} ${styles.cmeF26}`} type="submit" onClick={onSubmit}>
          Submit
        </button>
      </div>

      <ContactInfo />
    </>
  );
};

export default CMESearchForm;